import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Tooltip from "module-common/Tooltip";
import { Graphics } from "constant";

export default class IconMenu extends Component {
  static propTypes = {
    children: PropTypes.element,
    name: PropTypes.string,
    icon: PropTypes.string,
    iconSelected: PropTypes.string,
    tooltip: PropTypes.string,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func
  };
  static defaultProps = {
    isSelected: false
  };

  render() {
    const { children, tooltip, icon, iconSelected, ...rest } = this.props;
    const comp = (
      <Menu
        onClick={this.onClick}
        icon={Graphics[icon]}
        iconSelected={Graphics[iconSelected]}
        {...rest}
      >
        {children}
      </Menu>
    );
    if (tooltip) {
      return (
        <Tooltip onClick={this.onClick} position="right" text={tooltip}>
          {comp}
        </Tooltip>
      );
    } else {
      return comp;
    }
  }

  onClick = () => {
    const { name, onClick } = this.props;
    if (onClick) onClick(name);
  };
}

const Menu = styled.button`
  width: 60px;
  height: 40px;
  flex: none;
  display: flex;
  background-color: ${props => props.theme.sidemenuBackground};
  background-position: center;
  background-repeat: no-repeat;
  align-items: center;
  justify-content: center;
  border: none;
  transition: 0.1s;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  &:hover,
  .active > & {
    background-color: ${props => props.theme.sidemenuHover};
    border-left: 4px solid ${props => props.theme.sidemenuBorder};
  }
  ${props =>
    props.icon &&
    css`
      background-image: url(${props.icon});
    `};
  ${props =>
    props.iconSelected &&
    css`
      &:hover,
      .active > & {
        background-image: url(${props.iconSelected});
      }
    `};
`;



// WEBPACK FOOTER //
// ./src/module-sidemenu/IconMenu.js